export default __webpack_public_path__ + "static/media/Prim.597c894c.jpg";